<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
    <div class="form-group clear" cvModuleCxoneCustomSettingSection after="all" [moduleManager]="moduleManager">
        <label cvLocalizedText langSection="Current_Contacts_Module" langKey="Contact_States">Contact States</label>
        <cv-cxone-contact-state-descriptions-selector [(selectedIds)]="selectedIds"></cv-cxone-contact-state-descriptions-selector>
    </div>
</ng-container>
